import React, { FC } from 'react';
import { useObserver } from 'mobx-react-lite';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LinkedinShareButton, PinterestShareButton, TwitterShareButton, FacebookShareButton, WhatsappShareButton, TelegramShareButton} from 'react-share';
import { faFacebook, faLinkedin, faPinterest, faTwitter, faLinkedinIn, faXing, faWhatsapp, faTelegram} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './SocialLinkCreatedModal.scss';
import { useRootStore } from '../../root/RootStoreHooks';
import { FaCopy } from 'react-icons/fa';
interface Props {
  show: boolean;
  newSlMode?: boolean;
  template?: any;
}

export const SocialLinkCreatedModal: FC<Props> = ({ show, newSlMode = false }) => {
  const { t } = useTranslation();
  const rootStore = useRootStore();
  const store = rootStore.moduleStores.socialLinkCreatorEntry!;

  return useObserver(() => (
    <Modal className={newSlMode ? 'sl-modal' : "social-link-created-modal" } show={show} keyboard={false} backdrop="static" role="dialog">
      <Modal.Header closeButton>
        <Modal.Title><p className='sl-modal-title'>{t('SocialLinkCreatedModal_SocialLinkCreated')}</p></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='sl-modal-container'>
          <p className='sl-modal-p'>{t('SocialLinkCreatedModal_Congratulations')}</p>
          <p className='sl-modal-p'>{t('SocialLinkCreatedModal_SuccessSocialLinkCreated')}</p>
            {newSlMode && 
            <>
              <div className="sl-modal-created-link-container">
                <span className='sl-modal-created-link'>{store.socialLink}</span>
                <Button className='sl-modal-copy-button' onClick={() => store.copySocialLink()}>
                  <FaCopy></FaCopy>
                </Button>
              </div>
              <p className='sl-modal-created-link-copy-message'>{t('SocialLinkCreatedModal_CopyLinkMessage')}</p>
            </>}
            {!newSlMode && 
            <div>
              <span>{store.socialLink}</span>
              <div>{t('SocialLinkCreatedModal_CopyLinkMessage')}</div>
            </div>}
          <div className="social-link-share-buttons sl-social-buttons">
            <FacebookShareButton
              url={store.socialLink}
              translate="yes"
              beforeOnClick={() => store.addShareStatus('facebook')}
            >
              <FontAwesomeIcon size="2x" icon={faFacebook} />
            </FacebookShareButton>
            <TwitterShareButton
              url={store.socialLink}
              translate="yes"
              beforeOnClick={() => store.addShareStatus('twitter')}
            >
              <FontAwesomeIcon size="2x" icon={faTwitter} />
            </TwitterShareButton>
            <PinterestShareButton
              url={store.socialLink}
              media={'https://static.youngliving.com/EU-DOCS/IMGS/product_guides/Cover-ProductGuide-2020-DE.jpg'}
              translate="yes"
              beforeOnClick={() => store.addShareStatus('pinterest')}
            >
              <FontAwesomeIcon size="2x" icon={faPinterest} />
            </PinterestShareButton>
            <LinkedinShareButton
              url={store.socialLink}
              translate="yes"
              beforeOnClick={() => store.addShareStatus('linkedin')}
            >
              <FontAwesomeIcon size="2x" icon={faLinkedin} />
            </LinkedinShareButton>
            <WhatsappShareButton
              url={store.socialLink}
              translate="yes"
              beforeOnClick={() => store.addShareStatus('whatsapp')}
              >
              <FontAwesomeIcon size="2x" icon={faWhatsapp} />
            </WhatsappShareButton>
            <TelegramShareButton
              url={store.socialLink}
              translate="yes"
              beforeOnClick={() => store.addShareStatus('telegram')}
            >
              <FontAwesomeIcon size="2x" icon={faTelegram} />
            </TelegramShareButton>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {!newSlMode && <>
          <Button variant={'outline-secondary'} onClick={() => store.redirectToVO()}>
          {t('SocialLinkCreatedModal_Close')}
          </Button>
          <Button
            variant={store.socialLinkCopied ? 'outline-warning' : 'warning'}
            disabled={store.socialLinkCopied}
            onClick={() => store.copySocialLink()}
          >
            {store.socialLinkCopied
              ? t('SocialLinkCreatedModal_CopiedToClipboard')
              : t('SocialLinkCreatedModal_CopyToClipboard')}
          </Button>
        </>}
        {newSlMode && <>
          <Button className='sl-modal-created-close-btn' onClick={() => store.redirectToVO()}>
            {t('SocialLinkCreatedModal_Close')}
          </Button>
          <Button className='sl-modal-created-copy-btn' onClick={() => store.copySocialLink()}>
              {t('SocialLinkCreatedModal_CopyToClipboard')}
          </Button>
        </>}
        
      </Modal.Footer>
    </Modal>
  ));
};
